// EN/RO strings for WOW Journey wizard + results. Keep RO diacritics correct.
// Any backend-generated prose comes from /app/backend/wow_journey/templates.py.
export const WJ = {
  // Homepage band
  band: {
    name: "WOW Journey",
    headline_en: "Your Romania. Your way.",
    headline_ro: "România ta. În ritmul tău.",
    desc_en: "A few simple choices. A journey shaped around you.",
    desc_ro: "Câteva alegeri simple. O călătorie pe gustul tău.",
    cta_en: "Plan my trip →",
    cta_ro: "Creează-mi itinerariul →",
  },

  // Wizard shell
  shell: {
    title_en: "Plan your Romania trip", title_ro: "Planifică-ți călătoria în România",
    sub_en: "Three short steps. Honest estimates. Edit anything before you leave.",
    sub_ro: "Trei pași scurți. Estimări sincere. Poți edita orice înainte de plecare.",
    step_label_en: "Step {n} of 3", step_label_ro: "Pasul {n} din 3",
    back_en: "Back", back_ro: "Înapoi",
    next_en: "Continue", next_ro: "Continuă",
    plan_en: "Plan my trip", plan_ro: "Creează itinerariul",
    required_en: "Please answer this to continue.", required_ro: "Răspunde la asta pentru a continua.",
  },

  // Step 1
  s1: {
    heading_en: "Start and time", heading_ro: "Startul și timpul",
    where_start_en: "Where will your trip start?", where_start_ro: "De unde începe călătoria?",
    search_city_en: "City or airport…", search_city_ro: "Oraș sau aeroport…",
    undecided_en: "I haven't decided", undecided_ro: "Nu m-am hotărât",
    when_en: "When are you visiting?", when_ro: "Când vrei să călătorești?",
    exact_dates_en: "Exact dates", exact_dates_ro: "Date exacte",
    approx_month_en: "Approximate month", approx_month_ro: "Lună aproximativă",
    not_sure_en: "Not sure yet", not_sure_ro: "Încă nu știu",
    days_en: "How many days can you spend exploring?", days_ro: "Câte zile ai la dispoziție pentru explorare?",
    d_1_en: "1 day", d_1_ro: "1 zi",
    d_2_3_en: "2–3 days", d_2_3_ro: "2–3 zile",
    d_4_7_en: "4–7 days", d_4_7_ro: "4–7 zile",
    d_8_14_en: "8–14 days", d_8_14_ro: "8–14 zile",
    d_custom_en: "Custom", d_custom_ro: "Personalizat",
    family_toggle_en: "I'm also visiting family or friends", family_toggle_ro: "Vizitez și familia sau prietenii",
    family_base_en: "Family / friends base (city)", family_base_ro: "Baza familiei / prietenilor (oraș)",
    blocked_days_en: "Days blocked for family (approx.)", blocked_days_ro: "Zile ocupate cu familia (aprox.)",
    where_end_en: "Where should your trip finish?", where_end_ro: "Unde vrei să se încheie călătoria?",
    end_same_en: "Return to the starting point", end_same_ro: "Mă întorc la punctul de plecare",
    end_other_en: "Another city or airport", end_other_ro: "Alt oraș sau aeroport",
    season_spring_en: "Spring (Mar–May)", season_spring_ro: "Primăvară (mar–mai)",
    season_summer_en: "Summer (Jun–Aug)", season_summer_ro: "Vară (iun–aug)",
    season_fall_en: "Autumn (Sep–Nov)", season_fall_ro: "Toamnă (sep–nov)",
    season_winter_en: "Winter (Dec–Feb)", season_winter_ro: "Iarnă (dec–feb)",
  },

  // Step 2
  s2: {
    heading_en: "Travel style", heading_ro: "Stilul călătoriei",
    transport_en: "How will you move around?", transport_ro: "Cum te deplasezi?",
    t_car_en: "Own or rental car", t_car_ro: "Mașină proprie sau închiriată",
    t_train_en: "Train and local transport", t_train_ro: "Tren și transport local",
    t_undecided_en: "Not decided", t_undecided_ro: "Încă nu știu",
    interests_en: "What are you most interested in?  (choose up to 3)", interests_ro: "Ce te interesează cel mai mult?  (max. 3)",
    i_castles_history_en: "Castles and history", i_castles_history_ro: "Castele și istorie",
    i_towns_culture_en: "Towns and culture", i_towns_culture_ro: "Orașe și cultură",
    i_scenic_views_en: "Scenic views with easy access", i_scenic_views_ro: "Priveliști accesibile",
    i_food_local_en: "Food and local experiences", i_food_local_ro: "Mâncare și experiențe locale",
    i_nature_walking_en: "Nature and walking", i_nature_walking_ro: "Natură și plimbări",
    i_relaxation_wellness_en: "Relaxation and wellness", i_relaxation_wellness_ro: "Relaxare și wellness",
    i_family_en: "Family activities", i_family_ro: "Activități de familie",
    i_surprise_me_en: "Surprise me", i_surprise_me_ro: "Surprinde-mă",
    pace_en: "What pace do you prefer?", pace_ro: "Ce ritm preferi?",
    p_relaxed_en: "Relaxed", p_relaxed_ro: "Relaxat",
    p_balanced_en: "Balanced", p_balanced_ro: "Echilibrat",
    p_active_en: "Active", p_active_ro: "Activ",
  },

  // Step 3
  s3: {
    heading_en: "Companions and comfort", heading_ro: "Companie și confort",
    group_en: "Who's travelling?", group_ro: "Cu cine călătorești?",
    g_solo_en: "Solo", g_solo_ro: "Singur(ă)",
    g_couple_en: "Couple", g_couple_ro: "În cuplu",
    g_family_en: "Family", g_family_ro: "În familie",
    g_friends_en: "Friends", g_friends_ro: "Cu prieteni",
    group_size_en: "How many of you?", group_size_ro: "Câți sunteți?",
    children_en: "Children in the group", children_ro: "Copii în grup",
    budget_en: "Budget style", budget_ro: "Stil de buget",
    b_economical_en: "Economical", b_economical_ro: "Econom",
    b_comfortable_en: "Comfortable", b_comfortable_ro: "Confortabil",
    b_premium_en: "Premium", b_premium_ro: "Premium",
    b_not_sure_en: "Not sure", b_not_sure_ro: "Nu știu",
    budget_note_en: "Indicates travel style — not a quoted package.", budget_note_ro: "Indică stilul — nu un pachet cu preț fix.",
    prefs_en: "A few preferences (optional)", prefs_ro: "Câteva preferințe (opțional)",
    pref_no_hiking_en: "No hiking", pref_no_hiking_ro: "Fără drumeții",
    pref_minimize_stairs_en: "Minimize stairs and long walks", pref_minimize_stairs_ro: "Mai puține scări și plimbări lungi",
    pref_avoid_long_drives_en: "Avoid long drives", pref_avoid_long_drives_ro: "Fără drumuri lungi",
    pref_avoid_mountain_roads_en: "Avoid mountain roads", pref_avoid_mountain_roads_ro: "Fără drumuri de munte",
    pref_avoid_after_dark_en: "Avoid travel after dark", pref_avoid_after_dark_ro: "Fără deplasări după lăsarea serii",
    pref_keep_one_base_en: "Keep the same accommodation base", pref_keep_one_base_ro: "Păstrează aceeași bază de cazare",
    must_see_en: "Must-see places (one per line)", must_see_ro: "Locuri obligatorii (unul pe linie)",
    must_avoid_en: "Places to avoid (one per line)", must_avoid_ro: "Locuri de evitat (unul pe linie)",
  },

  // Results
  r: {
    primary_en: "Recommended for you", primary_ro: "Recomandat pentru tine",
    alternatives_en: "Alternatives", alternatives_ro: "Alternative",
    day_label_en: "Day {n}", day_label_ro: "Ziua {n}",
    morning_en: "Morning", morning_ro: "Dimineață",
    afternoon_en: "Afternoon", afternoon_ro: "După-amiază",
    evening_en: "Evening (optional)", evening_ro: "Seara (opțional)",
    based_in_en: "Based in", based_in_ro: "Bază",
    transfer_en: "approx. transfer", transfer_ro: "transfer aprox.",
    overnight_en: "Overnight", overnight_ro: "Cazare",
    return_no_acc_en: "Return to {city} — no accommodation included", return_no_acc_ro: "Întoarcere în {city} — cazarea nu este inclusă",
    sources_en: "Verify with", sources_ro: "Verifică la",
    stairs_high_en: "Many steps / steep access", stairs_high_ro: "Multe trepte / acces abrupt",
    stairs_moderate_en: "Some steps", stairs_moderate_ro: "Trepte moderate",
    mountain_road_en: "Mountain road segment", mountain_road_ro: "Segment de drum de munte",
    refine_en: "Refine this trip", refine_ro: "Rafinează călătoria",
    refine_relaxed_en: "Make it more relaxed", refine_relaxed_ro: "Mai relaxat",
    refine_reduce_driving_en: "Reduce driving", refine_reduce_driving_ro: "Redu condusul",
    refine_one_base_en: "Keep one accommodation base", refine_one_base_ro: "O singură bază",
    refine_remove_hiking_en: "Remove hiking", refine_remove_hiking_ro: "Fără drumeții",
    refine_budget_up_en: "Step budget up", refine_budget_up_ro: "Buget mai mare",
    refine_budget_down_en: "Step budget down", refine_budget_down_ro: "Buget mai mic",
    print_en: "Print this plan", print_ro: "Tipărește itinerariul",
    discuss_en: "Discuss this trip with Concierge", discuss_ro: "Discută itinerariul cu Concierge",
    recommend_header_en: "Why this fits you", recommend_header_ro: "De ce ți se potrivește",
    budget_label_en: "Budget range", budget_label_ro: "Interval buget",
    overnight_bases_en: "Overnight bases", overnight_bases_ro: "Baze de cazare",
    driving_load_en: "Driving load", driving_load_ro: "Volum condus",
    driving_light_en: "Light", driving_light_ro: "Redus",
    driving_moderate_en: "Moderate", driving_moderate_ro: "Moderat",
    driving_heavy_en: "Heavy", driving_heavy_ro: "Ridicat",
    map_label_en: "Route map", map_label_ro: "Harta rutei",
    open_in_maps_en: "Open in Google Maps", open_in_maps_ro: "Deschide în Google Maps",
    disclaimer_header_en: "Honest notes", disclaimer_header_ro: "Note sincere",
    start_over_en: "Start over", start_over_ro: "Pornește din nou",
    loading_en: "Shaping your journey…", loading_ro: "Îți construim călătoria…",
    error_en: "Something went wrong — your answers are saved. Try again.",
    error_ro: "Ceva n-a mers — răspunsurile sunt păstrate. Încearcă din nou.",
    empty_en: "We couldn't shape a trip from these choices.", empty_ro: "Nu am putut construi o călătorie din aceste alegeri.",
    empty_body_en: "Try widening your interests, adding days, or removing one exclusion.",
    empty_body_ro: "Lărgește interesele, adaugă zile sau elimină o excludere.",
    concierge_prefill_header_en: "I'm planning this trip in Romania — would love your take:",
    concierge_prefill_header_ro: "Îmi planific această călătorie în România — vreau părerea ta:",
    concierge_notice_en: "The message is prefilled — review it before sending. Nothing is sent automatically.",
    concierge_notice_ro: "Mesajul este completat în prealabil — verifică-l înainte de a-l trimite. Nu se trimite nimic automat.",
    nearby_header_en: "Stays & experiences near your bases",
    nearby_header_ro: "Cazări și experiențe aproape de bazele tale",
    nearby_proximity_en: "Straight-line proximity — real driving distance will be longer.",
    nearby_proximity_ro: "Distanță în linie dreaptă — distanța reală pe drum va fi mai mare.",
    nearby_near_label_en: "Near",
    nearby_near_label_ro: "Lângă",
    nearby_open_en: "Open listing →",
    nearby_open_ro: "Deschide anunțul →",
    nearby_disclaimer_en: "No availability, prices, ratings, or partnerships are shown here. Please check each listing's page for details.",
    nearby_disclaimer_ro: "Aici nu se afișează disponibilitate, prețuri, rating-uri sau parteneriate. Consultă pagina fiecărui anunț pentru detalii.",
  },
};

export function wj(path, locale = "en", vars = {}) {
  const parts = path.split(".");
  const leaf = parts.pop();
  let cur = WJ;
  for (const p of parts) { cur = cur?.[p]; if (!cur) return path; }
  let val = cur[`${leaf}_${locale}`] ?? cur[`${leaf}_en`] ?? path;
  for (const k of Object.keys(vars)) val = String(val).replaceAll(`{${k}}`, vars[k]);
  return val;
}

// Shortcut: lookup object { key_en, key_ro } by base key.
export function wjo(obj, key, locale = "en") {
  if (!obj) return "";
  return obj[`${key}_${locale}`] ?? obj[`${key}_en`] ?? "";
}
